import React from "react";
import { Switch, FormControlLabel } from "@mui/material";

const AppToggle = ({
  checked,
  onChange,
  labelOn = "On",
  labelOff = "Off",
  className = "",
  disabled = false,
}) => {
  return (
    <FormControlLabel
      control={
        <Switch
          checked={checked}
          onChange={(e) => onChange?.(e.target.checked)}
          color="primary"
          disabled={disabled}
        />
      }
      label={checked ? labelOn : labelOff}
      className={`text-gray-700 font-medium ${className}`}
    />
  );
};

export default AppToggle;
